var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99999 0.666748C4.39999 0.666748 0.666656 4.40008 0.666656 9.00008C0.666656 13.6001 4.39999 17.3334 8.99999 17.3334C13.6 17.3334 17.3333 13.6001 17.3333 9.00008C17.3333 4.40008 13.6 0.666748 8.99999 0.666748ZM8.99999 3.16675C10.3833 3.16675 11.5 4.28341 11.5 5.66675C11.5 7.05008 10.3833 8.16675 8.99999 8.16675C7.61666 8.16675 6.49999 7.05008 6.49999 5.66675C6.49999 4.28341 7.61666 3.16675 8.99999 3.16675ZM8.99999 15.0001C6.91666 15.0001 5.07499 13.9334 3.99999 12.3167C4.02499 10.6584 7.33332 9.75008 8.99999 9.75008C10.6583 9.75008 13.975 10.6584 14 12.3167C12.925 13.9334 11.0833 15.0001 8.99999 15.0001Z",
    fill: "#CAD0E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.837340f80c67eff75a044a0d486b8c12.svg";
export { ForwardRef as ReactComponent };